import React from 'react';

const ScoreBBw = (props) => (
    <svg viewBox="0 0 59.53 59.53" xmlns="http://www.w3.org/2000/svg" {...props}>
      <defs>
        <linearGradient
          id="B_bw_svg__a"
          x1={286.3}
          y1={29.76}
          x2={-72.82}
          y2={29.76}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#222" />
          <stop offset={1} stopColor="#ababab" />
        </linearGradient>
      </defs>
      <g data-name="Vrstva 2">
        <circle
          cx={29.76}
          cy={29.76}
          r={29.76}
          style={{
            fill: "url(#B_bw_svg__a)",
          }}
        />
        <path
          d="M19.19 16.42h9.55c4.36 0 7.52.55 9.48 1.67a5.66 5.66 0 0 1 3 5.32 6.23 6.23 0 0 1-1.29 4.06 5.27 5.27 0 0 1-3.43 1.91v.19a7 7 0 0 1 4.21 2.19A6.61 6.61 0 0 1 42 36a6.78 6.78 0 0 1-3 5.9c-2 1.41-4.76 2.11-8.24 2.11H19.19Zm6.51 10.94h3.78a7.55 7.55 0 0 0 3.83-.74 2.65 2.65 0 0 0 1.19-2.44 2.36 2.36 0 0 0-1.3-2.27 9.07 9.07 0 0 0-4.08-.69H25.7Zm0 4.65v7.2h4.24a6.82 6.82 0 0 0 4-.93 3.27 3.27 0 0 0 1.28-2.83c0-2.3-1.82-3.44-5.46-3.44Z"
          style={{
            fill: "#fff",
          }}
        />
      </g>
    </svg>
  );
  
  export default ScoreBBw;